import { Modal } from '@components';
import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { bool, func } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getButtonWidth, styles } from './RegisterToContinueModal.styles';

const RegisterToContinueModal = ({ isVisible, onClose, setModalVisible }) => {
  const {
    i18n: { t },
  } = useTranslation();
  const { isTabletSM } = useScreenSize();

  const handleModalClose = (state) => () => {
    onClose(state);
    setModalVisible(false);
  };

  return (
    <Modal
      isVisible={isVisible}
      modalContainerProps={styles.modalContainerProps}
      setModalVisible={setModalVisible}
      withBackdropNoise
    >
      <Flex
        color={theme.colors.white[100]}
        flexDirection="column"
        gap={40}
        p={40}
      >
        <Typography
          variant={isTabletSM ? 'BN-bold-s24-lh21' : 'BN-bold-s36-lh75'}
        >
          {t('RegisterToContinueModal.Title')}
        </Typography>

        <Typography
          maxWidth={618}
          variant={isTabletSM ? 'MS-regular-s16-lh25' : 'MS-regular-s24-lh37'}
        >
          {t('RegisterToContinueModal.Description')}
        </Typography>
        <Flex justifyContent="space-between">
          <Button
            onClick={handleModalClose('signIn')}
            variant="secondary"
            width={getButtonWidth({ isTabletSM })}
          >
            <Typography variant="MS-regular-s16-lh25">
              {t('RegisterToContinueModal.LogIn')}
            </Typography>
          </Button>
          <Button
            onClick={handleModalClose('signUp')}
            variant="primary"
            width={getButtonWidth({ isTabletSM })}
          >
            <Typography variant="MS-regular-s16-lh25">
              {t('RegisterToContinueModal.Register')}
            </Typography>
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

RegisterToContinueModal.propTypes = {
  isVisible: bool.isRequired,
  onClose: func.isRequired,
  setModalVisible: func.isRequired,
};

export default RegisterToContinueModal;
